import axios from 'axios'

const getRegion = () => import.meta.env.VITE_AWS_REGION || 'us-east-2'
const getDeviceClientId = () => import.meta.env.VITE_DEVICE_COGNITO_CLIENT_ID

const getCognitoUrl = () => `https://cognito-idp.${getRegion()}.amazonaws.com/`

const cognitoRequest = async <T>(target: string, body: Record<string, unknown>): Promise<T> => {
  const response = await axios.post(getCognitoUrl(), body, {
    headers: {
      'Content-Type': 'application/x-amz-json-1.1',
      'X-Amz-Target': `AWSCognitoIdentityProviderService.${target}`,
    },
  })
  return response.data
}

export const CognitoDeviceAuthService = {
  initiateCustomAuth: (
    username: string,
    clientId?: string
  ): Promise<{
    Session: string
    ChallengeParameters: { ANSWER: string }
    ChallengeName: string
  }> => {
    return cognitoRequest('InitiateAuth', {
      AuthFlow: 'CUSTOM_AUTH',
      ClientId: clientId || getDeviceClientId(),
      AuthParameters: {
        USERNAME: username,
      },
    })
  },

  respondToChallenge: (
    username: string,
    answer: string,
    session: string,
    clientId?: string
  ): Promise<{
    ChallengeName?: string
    Session?: string
    AuthenticationResult?: {
      IdToken: string
      AccessToken: string
      RefreshToken: string
    }
  }> => {
    return cognitoRequest('RespondToAuthChallenge', {
      ClientId: clientId || getDeviceClientId(),
      ChallengeName: 'CUSTOM_CHALLENGE',
      ChallengeResponses: {
        USERNAME: username,
        ANSWER: answer,
      },
      Session: session,
    })
  },

  refreshSession: (
    refreshToken: string,
    clientId?: string
  ): Promise<{
    AuthenticationResult: {
      IdToken: string
      AccessToken: string
    }
  }> => {
    return cognitoRequest('InitiateAuth', {
      AuthFlow: 'REFRESH_TOKEN_AUTH',
      ClientId: clientId || getDeviceClientId(),
      AuthParameters: {
        REFRESH_TOKEN: refreshToken,
      },
    })
  },
}
